import React, { createContext, useState, useEffect, useCallback } from "react";
import axiosInstance from "../api/axiosInstance";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const login = async (token) => {
    localStorage.setItem("token", token);
    setLoading(true);
    await fetchUser();
  };

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    setUser(null);
    setLoading(false);
  }, []);

  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const res = await axiosInstance.get("users/account");
      setUser(res.data);
    } catch (error) {
      logout();
    } finally {
      setLoading(false);
    }
  }, [logout]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const hasPermission = (resource, action) => {
    // Kein Benutzer
    if (!user) return false;

    return !!user?.permissions?.[resource]?.[action];
  };

  return (
    <AuthContext.Provider value={{ user, hasPermission, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};